import { useState, useEffect } from "react";
import { notifyApiError } from "src/share/utils/notifyApiError";
import { CaseFilters, FilterType } from "src/share/components/Filters/types";
import { IAgencyMetrics, initialAgencyMetrics } from "../types";
import { StatisticsService, StatsTypes } from "src/share/services/statistics";
import { momentToMiliseconds } from "src/share/utils/utils";

type DashboardStats = {
  metrics: IAgencyMetrics;
  filters: CaseFilters;
  isLoading: boolean;
  onApply: (filters) => void;
};

function formatFilters(newFilters): CaseFilters {
  const formattedFilters = {
    status: newFilters[FilterType.STATUS],
    caseType: newFilters[FilterType.CASE_TYPE],
    agency: newFilters[FilterType.AGENCY] || "ALL",
    region: "",
  };
  if (newFilters[FilterType.DATE_RANGE]) {
    return {
      ...formattedFilters,
      range: {
        gte: momentToMiliseconds(newFilters[FilterType.DATE_RANGE].startDate),
        lte: momentToMiliseconds(newFilters[FilterType.DATE_RANGE].endDate),
      },
    };
  }
  return formattedFilters;
}

function useStats(): DashboardStats {
  const [filters, setFilters] = useState<CaseFilters>({
    agency: "ALL", // TO BE FIXED
    region: "",
    status: "ALL",
  });
  const [metrics, setMetrics] = useState<IAgencyMetrics>(initialAgencyMetrics);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    async function fetchtMetrics(): Promise<void> {
      try {
        setIsLoading(true);
        const request = {
          agencyCode: filters.agency || "ALL",
          status: filters.status,
          caseType: filters.caseType,
          state: filters.region,
          range: filters.range,
        };
        const newMetrics = await StatisticsService.getStats(
          StatsTypes.CASES,
          request
        );
        setIsLoading(false);
        setMetrics(newMetrics);
      } catch (error) {
        setIsLoading(false);
        notifyApiError("Error", "There was a problem loading the stats");
      }
    }
    fetchtMetrics();
  }, [filters]);
  function onApply(newFilters): void {
    const formattedFilters = formatFilters(newFilters);
    setFilters(formattedFilters);
  }

  return { metrics, filters, isLoading, onApply };
}

export default useStats;
